var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488,96H456V48a8.00008,8.00008,0,0,0-8-8H272a8.00008,8.00008,0,0,0-8,8V160a8.00008,8.00008,0,0,0,8,8h64v16.57715a24.06284,24.06284,0,0,0-18.417,18.71631L313.44141,224H280a24.0275,24.0275,0,0,0-24,24v57.2229a88.48884,88.48884,0,0,0-17.39648-6.675L176,281.85364V251.88037A88.56349,88.56349,0,0,0,206.50635,200h17.727A23.79369,23.79369,0,0,0,248,176.23389V143.76611a23.71011,23.71011,0,0,0-8-17.76239V104a88.09957,88.09957,0,0,0-88-88H120a88.09957,88.09957,0,0,0-88,88v22.0033a23.71063,23.71063,0,0,0-8,17.76281v32.46778A23.79285,23.79285,0,0,0,47.76562,200h17.728A88.56349,88.56349,0,0,0,96,251.88037v29.97327L33.39648,298.54785a88.0147,88.0147,0,0,0-21.40332,8.85889l8.01368,13.84863a71.98721,71.98721,0,0,1,17.51269-7.24756L105.04883,296h61.90234l67.5293,18.00781a71.8233,71.8233,0,0,1,52.78808,59.84082l9.20459,67.49817L232,454.24146V384H216V496h16V470.55859l66.63916-13.32788,5.43408,39.85034,15.85352-2.1621-1.06446-7.80542L336,459.26477V496h16V400h16v96h16V459.26489l25.18652,40.928,13.627-8.38574L384,428.73547V400h3.5293l61.65722,100.19287,13.627-8.38574L400,389.73523V368h40a24.0275,24.0275,0,0,0,24-24v-8h24a8.00008,8.00008,0,0,0,8-8V104A8.00008,8.00008,0,0,0,488,96ZM232,143.76611v32.46778A7.77536,7.77536,0,0,1,224.2334,184H208V136h16.2334A7.77536,7.77536,0,0,1,232,143.76611ZM64,184H47.76562A7.77452,7.77452,0,0,1,40,176.23389V143.76611A7.77452,7.77452,0,0,1,47.76562,136H64Zm0-70.11133V120H48V104a72.08124,72.08124,0,0,1,72-72h32a72.08124,72.08124,0,0,1,72,72v16H208v-6.11133A65.9634,65.9634,0,0,0,142.11133,48H129.88867A65.9634,65.9634,0,0,0,64,113.88867ZM160,280H112V256h48Zm5.24512-40H106.75488A72.36774,72.36774,0,0,1,80,184V113.88867A49.94506,49.94506,0,0,1,129.88867,64h12.22266A49.94506,49.94506,0,0,1,192,113.88867V184A72.36774,72.36774,0,0,1,165.24512,240ZM280,152V56H440v96Zm88,16v16H352V168ZM303.12207,371.68652c-.16895-1.23779-.36914-2.46533-.58813-3.68652H320v21.73523l-11.80151,19.17761ZM336,428.73523l-20.54565,33.3866-3.8479-28.21729L332.4707,400H336ZM384,384H336V368h48Zm64-40a8.00917,8.00917,0,0,1-8,8H298.08032A87.6718,87.6718,0,0,0,272,315.72V248a8.00917,8.00917,0,0,1,8-8h40a7.99993,7.99993,0,0,0,7.84473-6.43115l5.42773-27.13819A8.021,8.021,0,0,1,341.11719,200h37.76562a8.021,8.021,0,0,1,7.84473,6.43115l5.42773,27.1377A8.00081,8.00081,0,0,0,399.98047,240l40.03808.09619a8.01343,8.01343,0,0,1,7.98145,8Zm32-24H464V248.09619a24.05157,24.05157,0,0,0-16-22.62091V216H432v8.07678l-25.43848-.06116L402.417,203.294A24.06285,24.06285,0,0,0,384,184.57715V168h64a8.00008,8.00008,0,0,0,8-8V112h24Z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.99982,
    y: 65.37258,
    width: 16.00036,
    height: 45.25483,
    transform: "translate(57.27504 314.27417) rotate(-45)",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.99982,
    y: 58.74517,
    width: 16.00036,
    height: 90.50967,
    transform: "translate(38.93189 301.9899) rotate(-45)",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 216,
    width: 32,
    height: 16,
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,256H296a8.00008,8.00008,0,0,0-8,8v64a8.00008,8.00008,0,0,0,8,8h96a8.00008,8.00008,0,0,0,8-8V264A8.00008,8.00008,0,0,0,392,256Zm-8,64H304V272h80Z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 256,
    width: 16,
    height: 16,
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 288,
    width: 16,
    height: 16,
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 320,
    width: 16,
    height: 16,
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40 454.241 17.569 449.755 14.431 465.445 40 470.559 40 496 56 496 56 384 40 384 40 454.241",
    fill: "#c72538"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideography);
export default __webpack_public_path__ + "static/media/videography.3fc2551f501bdb6ef6a136cf65a6cf27.svg";
export { ForwardRef as ReactComponent };